import { render, staticRenderFns } from "./TraxAccountRoleEdit.vue?vue&type=template&id=6dfeb41c"
import script from "./TraxAccountRoleEdit.vue?vue&type=script&lang=js"
export * from "./TraxAccountRoleEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports